/*>
* @license
* Copyright (c) 2014-2022 ABILITY Network, Inc., an INOVALON, Inc. company. All Rights Reserved.
* 
* This computer program is CONFIDENTIAL and a TRADE SECRET of ABILITY Network, Inc.
* The receipt or possession of this program does not convey any rights to use,
* reproduce or disclose its contents in whole or in part, without the specific
* written consent of ABILITY Network, Inc. Any use, reproduction or disclosure of
* this program without the express written consent of ABILITY Network, Inc. is a
* violation of the copyright laws and may subject you to criminal prosecution.
<*/
import { injectable } from 'inversify'
import { IProductInfo, ISectionInfo, IArticleInfo } from '../ProductContentStateManager/contracts'
import { IProducts, ISection } from '../ProductStateManager/contracts'
import IProductsApiClient from './contracts'

@injectable()
export class MockProductsApiClient implements IProductsApiClient {
	public productInfo: IProductInfo

	public products: IProducts[]

	constructor() {
		this.productInfo = {
			productName: 'CAREWATCH',
			productDescription: 'Our mission at Carewatch is to provide high quality care outcomes for vulnerable people who want to live at home, independently.',
			sectionList: [
				{
					sectionName: 'Frequently Asked Questions',
					articleList: [
						{
							contentItemId: '4wh3zak4hk4tk19vkg3wajex4g',
							displayText: 'FAQ Scheduling Management Tools',
						} as IArticleInfo,
						{
							contentItemId: '4h2v5wfdq1vne332r1nffkbhmv',
							displayText: 'FAQ ICD-10 Clinical Categories Lookup Tool',
						} as IArticleInfo,
						{
							contentItemId: '40z8qacpns4vhtmsrxmxch5mcv',
							displayText: 'FAQ ICD-10 NTA Comorbidity Lookup Tool',
						} as IArticleInfo,
						{
							contentItemId: '47dp2kz399x7twzq51mfgav4cp',
							displayText: 'FAQ Transmission Watch',
						} as IArticleInfo,
					],
				} as ISectionInfo,

				{
					sectionName: 'Introduction and Navigation',
					articleList: [
						{
							contentItemId: '4pfvam6xzjbrw6m52p9t357jmz',
							displayText: 'IandN Scheduling Management Tools​',
						} as IArticleInfo,
						{
							contentItemId: '486x9q5jzha6zshv14yzhcsdms',
							displayText: 'IandN ICD-10 Clinical Categories Lookup Tool',
						} as IArticleInfo,
						{
							contentItemId: '4z49qc8ns5ajc4yybhnvmryrc0',
							displayText: 'IandN ICD-10 NTA Comorbidity Lookup Tool',
						} as IArticleInfo,
						{
							contentItemId: '4dhqcyvdfdm9c3psm5gsnthgmm',
							displayText: 'IandN Transmission Watch',
						} as IArticleInfo,
					],
				} as ISectionInfo,

				{
					sectionName: 'MDS',
					articleList: [
						{
							contentItemId: '41ey44b6ktrpj5b2wx7hq7c2n3',
							displayText: 'MDS Scheduling Management Tools​',
						} as IArticleInfo,
						{
							contentItemId: '4pekw346zyx00sk4yeg95sxp4q',
							displayText: 'ICD-10 Clinical Categories Lookup Tool',
						} as IArticleInfo,
						{
							contentItemId: '4hmjfm6yagjeb5w49ttpqhkewa',
							displayText: 'ICD-10 NTA Comorbidity Lookup Tool',
						} as IArticleInfo,
						{
							contentItemId: '43e00e63wyk8t69qtahgrw3hw9',
							displayText: 'MDS Transmission Watch',
						} as IArticleInfo,
					],
				} as ISectionInfo,

				{
					sectionName: 'Release Notes',
					articleList: [
						{
							contentItemId: '4gbcb393a8sffzz28nzgxsm64v',
							displayText: 'RN Scheduling Management Tools​',
						} as IArticleInfo,
						{
							contentItemId: '46q841xvcpbdwszfepd9tbehw2',
							displayText: 'RN ICD-10 Clinical Categories Lookup Tool',
						} as IArticleInfo,
						{
							contentItemId: '48s0yt1ympa4ywj3caqynhjwnh',
							displayText: 'RN ICD-10 NTA Comorbidity Lookup Tool',
						} as IArticleInfo,
						{
							contentItemId: '4x0r1eqj2c1aavwp4knvsajq5y',
							displayText: 'RN Transmission Watch',
						} as IArticleInfo,
					],
				} as ISectionInfo,

				{
					sectionName: 'Quality',
					articleList: [
						{
							contentItemId: '49bna13cxfgdbr28a3fp1jy8d7',
							displayText: 'Quality Scheduling Management Tools​',
						} as IArticleInfo,
						{
							contentItemId: '48ya7e4108rt2trehpgk922f5s',
							displayText: 'Quality ICD-10 Clinical Categories Lookup Tool',
						} as IArticleInfo,
						{
							contentItemId: '4bs9v4b49erhr5dqv2qq4txgc8',
							displayText: 'Quality ICD-10 NTA Comorbidity Lookup Tool',
						} as IArticleInfo,
						{
							contentItemId: '47cv3er179x56v1t4w23zznrcc',
							displayText: 'Quality Transmission Watch',
						} as IArticleInfo,
					],
				} as ISectionInfo,

				{
					sectionName: 'Performance',
					articleList: [
						{
							contentItemId: '422s7hcdmq0t11t7nxkrnnzgck',
							displayText: 'Performance Scheduling Management Tools​',
						} as IArticleInfo,
						{
							contentItemId: '456dx8j1mv84rzn7j1f0we09xw',
							displayText: 'Performance ICD-10 Clinical Categories Lookup Tool',
						} as IArticleInfo,
						{
							contentItemId: '4ns96xm7cdnafx891jn94b2q42',
							displayText: 'Performance ICD-10 NTA Comorbidity Lookup Tool',
						} as IArticleInfo,
						{
							contentItemId: '4b7jbpgah3t3arrajrc3vevjn5',
							displayText: 'Performance Transmission Watch',
						} as IArticleInfo,
					],
				} as ISectionInfo,
			],
		} as IProductInfo

		this.products = [
			{
				productName: 'CAREWATCH',
				productCode: 'CAREWATCH',
				sectionList: [{ sectionName: 'Frequently Asked Questions' } as ISection, { sectionName: 'Introduction and Navigation' } as ISection, { sectionName: 'MDS' } as ISection, { sectionName: 'Release Notes' } as ISection, { sectionName: 'Quality' } as ISection, { sectionName: 'Performance' } as ISection],
			} as IProducts,
			{
				productName: 'UBWATCH',
				productCode: 'UBWATCH',
				sectionList: [{ sectionName: 'Frequently Asked Questions' } as ISection, { sectionName: 'Introduction and Navigation' } as ISection, { sectionName: 'MDS' } as ISection, { sectionName: 'Release Notes' } as ISection, { sectionName: 'Quality' } as ISection, { sectionName: 'Performance' } as ISection],
			} as IProducts,
			{
				productName: 'EASE All Payer',
				productCode: 'EASE All Payer',
				sectionList: [{ sectionName: 'Frequently Asked Questions' } as ISection, { sectionName: 'Introduction and Navigation' } as ISection, { sectionName: 'MDS' } as ISection, { sectionName: 'Release Notes' } as ISection, { sectionName: 'Quality' } as ISection, { sectionName: 'Performance' } as ISection],
			} as IProducts,
			{
				productName: 'COMPLETE',
				productCode: 'COMPLETE',
				sectionList: [{ sectionName: 'Frequently Asked Questions' } as ISection, { sectionName: 'Introduction and Navigation' } as ISection, { sectionName: 'MDS' } as ISection, { sectionName: 'Release Notes' } as ISection, { sectionName: 'Quality' } as ISection, { sectionName: 'Performance' } as ISection],
			} as IProducts,
			{
				productName: 'OPTIMIZE',
				productCode: 'OPTIMIZE',
				sectionList: [{ sectionName: 'Frequently Asked Questions' } as ISection, { sectionName: 'Introduction and Navigation' } as ISection, { sectionName: 'MDS' } as ISection, { sectionName: 'Release Notes' } as ISection, { sectionName: 'Quality' } as ISection, { sectionName: 'Performance' } as ISection],
			} as IProducts,
		] //get productList from jwt
	}
	getProductsfromJwt(JwtToken: string): Promise<IProducts[]> {
		return new Promise<IProducts[]>(resolve => {
			setTimeout(() => resolve(this.products), 100)
		})
	}

	getProductInfoByProductCode(productCode: string): Promise<IProductInfo> {
		const $this = this
		return new Promise<IProductInfo>(resolve => {
			setTimeout(() => {
				if (productCode === 'CAREWATCH') {
					resolve($this.productInfo)
				} else {
					resolve({
						productName: 'UBWATCH',
						productDescription: 'ABILITY UBWATCH helps coordinate financial UB records, tracks patterns and trends, and makes sure you’re being reimbursed for the services provided. Ensure consistency between your MDS and claims by adding ABILITY UBWATCH to your ABILITY CAREWATCH® service',
						sectionList: [
							{
								sectionName: 'Frequently Asked Questions',
								articleList: [
									{
										contentItemId: '4hwb8yrq86hz1219ke2vr8v2dq',
										displayText: 'FAQ Scheduling Management Tools 1',
									} as IArticleInfo,
									{
										contentItemId: '4gd33q6wq4xegstdxjn25ab9ne',
										displayText: 'FAQ ICD-10 Clinical Categories Lookup Tool',
									} as IArticleInfo,
									{
										contentItemId: '4k0n8rg6105a1r6twemxbx4c58',
										displayText: 'FAQ ICD-10 NTA Comorbidity Lookup Tool',
									} as IArticleInfo,
									{
										contentItemId: '4math0w9gc33zrj0wm0bcf33ma',
										displayText: 'FAQ Transmission Watch',
									} as IArticleInfo,
								],
							} as ISectionInfo,

							{
								sectionName: 'Introduction and Navigation',
								articleList: [
									{
										contentItemId: '4j0rskgpayexawd25s0z8hj5dj',
										displayText: 'IandN Scheduling Management Tools​',
									} as IArticleInfo,
									{
										contentItemId: '486x9q5jzha6zshv14yzhcsdms',
										displayText: 'IandN ICD-10 Clinical Categories Lookup Tool',
									} as IArticleInfo,
									{
										contentItemId: '4vx3e4g5gfr7atdnvfz0aq8jxs',
										displayText: 'IandN ICD-10 NTA Comorbidity Lookup Tool',
									} as IArticleInfo,
									{
										contentItemId: '48j2egrphcqqywc976c95qb5mf',
										displayText: 'IandN Transmission Watch',
									} as IArticleInfo,
								],
							} as ISectionInfo,

							{
								sectionName: 'MDS',
								articleList: [
									{
										contentItemId: '4ve54wwtyst1zy6t9gacevrkxv',
										displayText: 'MDS Scheduling Management Tools​',
									} as IArticleInfo,
									{
										contentItemId: '4pry24q20bsvwz42nr62k1d1ce',
										displayText: 'ICD-10 Clinical Categories Lookup Tool',
									} as IArticleInfo,
									{
										contentItemId: '4asw3x4a1vk0nz7cryzrjtm6xq',
										displayText: 'ICD-10 NTA Comorbidity Lookup Tool',
									} as IArticleInfo,
									{
										contentItemId: '40b4555gt0hff07ks205cmfj55',
										displayText: 'MDS Transmission Watch',
									} as IArticleInfo,
								],
							} as ISectionInfo,

							{
								sectionName: 'Release Notes',
								articleList: [
									{
										contentItemId: '4fs35q64ccvwhr5qmrts44y14g',
										displayText: 'RN Scheduling Management Tools​',
									} as IArticleInfo,
									{
										contentItemId: '4h35vnmz52g1a3vq2d3dq7mtwm',
										displayText: 'RN ICD-10 Clinical Categories Lookup Tool',
									} as IArticleInfo,
									{
										contentItemId: '4y27tjmmn80twz9k7cp8dzyqd0',
										displayText: 'RN ICD-10 NTA Comorbidity Lookup Tool',
									} as IArticleInfo,
									{
										contentItemId: '4ry7pkpjetgrf59bdr2mjqfam2',
										displayText: 'RN Transmission Watch',
									} as IArticleInfo,
								],
							} as ISectionInfo,

							{
								sectionName: 'Quality',
								articleList: [
									{
										contentItemId: '41gvx4qnawgfh1pdbvsbd5eqd1',
										displayText: 'Quality Scheduling Management Tools​',
									} as IArticleInfo,
									{
										contentItemId: '4rw4fvj9nmree080e50czef6cb',
										displayText: 'Quality ICD-10 Clinical Categories Lookup Tool',
									} as IArticleInfo,
									{
										contentItemId: '46tqajdrjat6n6q123wsejdqdv',
										displayText: 'Quality ICD-10 NTA Comorbidity Lookup Tool',
									} as IArticleInfo,
									{
										contentItemId: '4kf5r1kxcf682z7zt3s5005cms',
										displayText: 'Quality Transmission Watch',
									} as IArticleInfo,
								],
							} as ISectionInfo,

							{
								sectionName: 'Performance',
								articleList: [
									{
										contentItemId: '4snwbw0h9m84r6sg6sy6bw904v',
										displayText: 'Performance Scheduling Management Tools​',
									} as IArticleInfo,
									{
										contentItemId: '4rc8c6qxkyjqrzy1904mavzh5j',
										displayText: 'Performance ICD-10 Clinical Categories Lookup Tool',
									} as IArticleInfo,
									{
										contentItemId: '4fp35jqxxgepd6xx2p4626dqn5',
										displayText: 'Performance ICD-10 NTA Comorbidity Lookup Tool',
									} as IArticleInfo,
									{
										contentItemId: '4b0s906sw16f33wmdv9h3czgx2',
										displayText: 'Performance Transmission Watch',
									} as IArticleInfo,
								],
							} as ISectionInfo,
						],
					} as IProductInfo)
				}
			}, 100)
		})
	}
}
